import { Tooltip } from "@mui/material";
import BrandAvatar from "../../Component/Avatar/Avatar";
import classes from "./CategoryMonitoring.module.css";
import { TOP_N, CONSENSUS_PENALTY, TOOLTIP_SX, withDisplayRanks, RankBreakdownTooltip } from "./consensus-utils";

function toScalePercent(avgRank) {
  const clamped = Math.min(Math.max(avgRank, 1), TOP_N);
  return Math.round(((clamped - 1) / (TOP_N - 1)) * 100);
}


function ChartVAxis() {
  const ticks = Array.from({ length: TOP_N }, (_, i) => i + 1);
  return (
    <div className={classes.chartVAxis}>
      {ticks.map((n, i) => (
        <span key={n} className={classes.chartVAxisTick} style={{ top: `${(i / (TOP_N - 1)) * 100}%` }}>
          {n}
        </span>
      ))}
    </div>
  );
}

function ConsensusChartColumn({ entry, domainMap, rankLabels }) {
  const percent = toScalePercent(entry.avgRank);
  const isNA = entry.avgRank >= CONSENSUS_PENALTY;

  return (
    <div className={classes.chartVCol}>
      <div className={classes.chartVTrack}>
        {!isNA && (
          <Tooltip
            title={<RankBreakdownTooltip name={entry.name} ranks={entry.ranks} rankLabels={rankLabels} />}
            arrow
            placement="top"
            componentsProps={{ tooltip: { sx: TOOLTIP_SX } }}
          >
            <div
              className={classes.chartMarker}
              style={{ top: `${percent}%` }}
            />
          </Tooltip>
        )}
      </div>
      <div className={classes.chartVAxisLabel}>
        <div className={classes.chartAvatar}>
          <BrandAvatar domainName={domainMap[entry.name] || "example.com"} brandName={entry.name} />
        </div>
        <span className={classes.chartVName}>{entry.name || "—"}</span>
      </div>
    </div>
  );
}

export default function CMConsensusCard({ title, entries, domainMap = {}, rankLabels, wide = false }) {
  const rankedEntries = withDisplayRanks(entries);

  if (wide) {
    return (
      <div className={classes.consensusCardWide}>
        <div className={classes.consensusCardHeader}>
          <span className={classes.consensusCardLabel}>{title}</span>
        </div>
        <div className={classes.chartVRow}>
          {rankedEntries.length > 0 && <ChartVAxis />}
          {rankedEntries.length > 0 ? (
            rankedEntries.map((entry, index) => (
              <ConsensusChartColumn
                key={entry.name || index}
                entry={entry}
                domainMap={domainMap}
                rankLabels={rankLabels}
              />
            ))
          ) : (
            <div className={classes.consensusRow}>
              <span className={classes.consensusName}>No data</span>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={classes.consensusCard}>
      <div className={classes.consensusCardHeader}>
        <span className={classes.consensusCardLabel}>{title}</span>
      </div>
      <div className={classes.consensusList}>
        {rankedEntries.length > 0 ? (
          rankedEntries.map((entry, index) => (
            <Tooltip
              key={entry.name || index}
              title={<RankBreakdownTooltip name={entry.name} ranks={entry.ranks} rankLabels={rankLabels} />}
              arrow
              placement="right"
              componentsProps={{ tooltip: { sx: TOOLTIP_SX } }}
            >
              <div className={classes.consensusRow}>
                <span className={classes.consensusRank}>{entry.displayRank}</span>
                <BrandAvatar domainName={domainMap[entry.name] || "example.com"} brandName={entry.name} />
                <span className={classes.consensusName}>{entry.name || "—"}</span>
              </div>
            </Tooltip>
          ))
        ) : (
          <div className={classes.consensusRow}>
            <span className={classes.consensusName}>No data</span>
          </div>
        )}
      </div>
    </div>
  );
}
